import { PdfViewerTool } from '../PdfViewer.constants'

// a group whose every tool is switched off drops out together with its divider
export const PDF_VIEWER_TOOLBAR_GROUPS = [
  { id: 'panels', tools: [PdfViewerTool.Thumbnails] },
  { id: 'view', tools: [PdfViewerTool.ViewControls, PdfViewerTool.Zoom] },
  { id: 'mode', tools: [PdfViewerTool.Pan] },
]

export const PDF_VIEWER_TOOLBAR_END_TOOLS = [PdfViewerTool.Search]
